module.exports = __webpack_public_path__ + "static/media/Payment Automation.45b3e8c4.JPG";